export default __webpack_public_path__ + "static/media/slide14.03ea3241.jpg";